/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  //document.addEventListener('theme:scroll', e => { console.log(e); });
 // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  //document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  //document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.querySelectorAll(".prevent_redirection").forEach(el => {
    el.addEventListener("click", function(e){
      e.preventDefault();
    })
  })
  
  
  
})();

document.addEventListener("DOMContentLoaded", function () {
    // Get references to elements
    const updateCartButton = document.querySelector("[data-update-button] button"); // Replace with your actual update button selector
    const quantityInputs = document.querySelectorAll("[data-quantity-input]"); // Replace with your actual quantity input selector
    const plusButtons = document.querySelectorAll("[data-increase-quantity]"); // Replace with your actual plus button selector
    const minusButtons = document.querySelectorAll("[data-decrease-quantity]"); // Replace with your actual minus button selector

    // Function to trigger update
    function triggerUpdate() {
        if (updateCartButton) {
            updateCartButton.click();
        }
    }

    // Event listener for direct input change
    quantityInputs.forEach(input => {
        input.addEventListener("input", function () {
            triggerUpdate();
        });
    });

    // Event listener for plus buttons
    plusButtons.forEach(button => {
        button.addEventListener("click", function () {
            triggerUpdate();
        });
    });

    // Event listener for minus buttons
    minusButtons.forEach(button => {
        button.addEventListener("click", function () {
            triggerUpdate();
        });
    });

    function countup(el, target) {
      
      el.style.display = 'inline-block';
      el.style.minWidth = el.offsetWidth + 'px';
      let speed = parseInt(el.dataset.speed);
      //console.log(parseInt(speed));
      
      if (isNaN(speed)) {
        speed = 10000;
      }

      let data = { count: 0 };
      anime({
        targets: data,
        count: [0, target],
        duration: speed,
        round: 1,
        delay: 200,
        easing: 'easeOutCubic',
        update() {
           el.innerText = data.count.toLocaleString() + '+';
        }
      });
    }
    
    function makeCountup(el) {
      const text = el.dataset.count;
      const target = parseInt(text, 10);
    
      const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio > 0) {
            countup(el, target);
            io.unobserve(entry.target);
          }
        });
      });
    
      io.observe(el);
    }
    
    const els = document.querySelectorAll('[data-countup]');
    
    if(els && els != undefined){
      els.forEach(makeCountup);
    }

    function insertAfter(newNode, existingNode) {
      existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
    }

      const ico = document.querySelector('.folioIcon');
    const folio_info = document.querySelector('.folio_info');
    
    if(ico && ico != undefined){
      ico.addEventListener('click', (e) => {
        e.preventDefault();
        folio_info.classList.toggle('show-block');
      });
    }


    function addElms(var_id,elem) {
        let variant_id = document.createElement("input");
            variant_id.setAttribute("type", "hidden");
            variant_id.setAttribute("name", 'items[1][id]');
            variant_id.setAttribute("data-folio", var_id);
            variant_id.setAttribute("value",  var_id );

        let quantity = document.createElement("input");
            quantity.setAttribute("type", "hidden");
            quantity.setAttribute("data-folio", var_id);
            quantity.setAttribute("name", "items[1][quantity]");
            quantity.setAttribute("value", "1");

            console.log(var_id)
            console.log(elem)

            insertAfter(variant_id, elem);
            insertAfter(quantity, elem);

        // document.head.appendChild(variant_id);
        // document.head.appendChild(quantity);
    }

    function removeElms(elms){
      const data_folio = document.querySelectorAll(elms);
      if(data_folio && data_folio != undefined){
        data_folio.forEach(input => {
          input.remove();
         });
      }
    }

    const folio = document.querySelectorAll('.container-folio input[name="folio"]');
    
    if(folio && folio != undefined){
      folio.forEach(input => {
        input.addEventListener("change", function () {
          console.log(this.checked)
          if(this.checked){
            addElms(this.dataset.var_id, document.querySelector('.product__block__buttons [name=id]'));
          }else{
            removeElms('[data-folio]');
          }
        });
       });
        
    }
    
    const contact_btn = document.querySelector('.satisfactionPoint [href="/pages/contact"][title="Contact Us"]:first-of-type');

    if(contact_btn && contact_btn != undefined){
      contact_btn.addEventListener('click', (w) => {
        w.preventDefault();
        let chat = document.querySelector("#chat-button").contentWindow.document.body.querySelector('button');
        if(chat && chat != undefined){
          chat.click()
        }
      });
    }
});
   document.addEventListener("DOMContentLoaded", function () {
    // Select all radio inputs with name 'Editon'
    const radioButtons = document.querySelectorAll("input[name='Editon']");
    
    // Function to handle change event
    function handleSelectionChange(event) {
        console.log("Selected option:", event.target.value);
    }

    // Attach change event listener to each radio button
    radioButtons.forEach(radio => {
        radio.addEventListener("change", handleSelectionChange);
    });

    // Select the last radio button by default
    if (radioButtons.length > 0) {
        const lastRadioButton = radioButtons[radioButtons.length - 1];
        lastRadioButton.checked = true;
        lastRadioButton.dispatchEvent(new Event("change"));
    }
});
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".toggle-checkbox").forEach(checkbox => {
        // Find the closest button container
        const buttonContainer = checkbox.closest(".checkbox-container").nextElementSibling;
        if (!buttonContainer || !buttonContainer.classList.contains("button-container")) return;

        const button1 = buttonContainer.querySelector(".button1");
        const button2 = buttonContainer.querySelector(".button2");

        function toggleButtons() {
            if (checkbox.checked) {
                button1.style.display = "none";
                button2.style.display = "block";
            } else {
                button1.style.display = "block";
                button2.style.display = "none";
            }
        }

        // Run on page load
        toggleButtons();

        // Listen for checkbox change
        checkbox.addEventListener("change", toggleButtons);
    });
});
document.addEventListener("DOMContentLoaded", function () {
    let checkboxes = document.querySelectorAll(".sync-checkbox"); // Use a common class for both checkboxes

    // Function to update local storage when checkbox is changed
    checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", function () {
            localStorage.setItem("checkboxState", checkbox.checked ? "checked" : "unchecked");
        });
    });

    // Function to retrieve and apply saved checkbox state
    let storedState = localStorage.getItem("checkboxState");
    if (storedState === "checked") {
        checkboxes.forEach((checkbox) => {
            checkbox.checked = true;
          localStorage.removeItem("checkboxState");
        });
       document.querySelector('#giftProductValue').value="yes";
      document.querySelector('.product__submit__buttons button').disabled = true;
    } else {
        checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
        });
        if(document.querySelector('.product__submit__buttons button'))document.querySelector('.product__submit__buttons button').disabled = false;
    }
});
    // Select all radio buttons inside the wrapper
    const radios = document.querySelectorAll('#radio-wrapper input[type="radio"]');
    const outputElement = document.getElementById('variant-price'); // Target element

    radios.forEach(radio => {
        radio.addEventListener('change', function () {
            if (this.checked) {
                // Get the data-value attribute
                const dataValue = this.getAttribute('data-price');
                
                // Update the output element
              if(dataValue){
                outputElement.textContent = `${dataValue}`;
              }
            }
        });
    });
    /* Code for Gift form - ATC Disabled, Fields Validation  */
    document.addEventListener('DOMContentLoaded', function () {
        const form = document.querySelector('.customGiftForm');
        const button = document.querySelector('.btn--add-to-cart');
        const checkbox = document.querySelector('.giftCheckBox');
        const giftProductValue = document.getElementById('giftProductValue');
    
        if (!form || !button || !checkbox || !giftProductValue) return;
    
        const requiredFields = form.querySelectorAll('input[required], textarea[required], select[required]');
    
        function areAllFieldsFilled() {
            return Array.from(requiredFields).every(field => field.value.trim() !== '');
        }
    
        function updateButtonAndGiftValue() {
            if (checkbox.checked) {
                giftProductValue.value = 'yes';
                button.disabled = !areAllFieldsFilled();
            } else {
                giftProductValue.value = '';
                button.disabled = false;
            }
        }
    
        // Event listeners for inputs to validate required fields
        requiredFields.forEach(field => {
            field.addEventListener('input', updateButtonAndGiftValue);
            field.addEventListener('change', updateButtonAndGiftValue);
        });
    
        // Checkbox toggle behavior
        checkbox.addEventListener('change', updateButtonAndGiftValue);
    
        // Initial check on page load
        updateButtonAndGiftValue();
    });
  function monthlyText(){
    if(document.querySelector('.product-options-wrapper input:checked')){
      let planDuration = document.querySelector('.product-options-wrapper input:checked').value.split('Subscription')[0].trim();
      if(planDuration.includes('6 Month') || planDuration.includes('2 Year')){
        planDuration = planDuration + 's';
      }
      if(document.querySelector('.giftCheck + p span')){
        document.querySelector('.giftCheck + p span').textContent = `One Letter Per Month for Duration of ${planDuration}`;   
      }    
    }
  }

  monthlyText();
  
  document.addEventListener('click', function(e) {
  var folioInfo = document.querySelector('.folio_info');
  if (folioInfo && e.target.className != 'folioIcon') {
    folioInfo.classList.remove('show-block');
  }
});


  document.addEventListener('change', function(e){
    monthlyText();
  })
  
  function checkFields() {
    let check = true;
    document.querySelectorAll('.giftFormFields input[required]').forEach(function (el, index) {
      if (el.value.length == 0) {
        check = false;
        el.classList.add('req');
        el.insertAdjacentHTML('afterend', '<div class="fieldError" style="font-size: 12px; color: #b31942;">This field is required</div>');
      } else {
        el.classList.remove('req');
      }
    })
    return check;
  }
  

  
  document.addEventListener('click', function(e) {
  var folioInfo = document.querySelector('.folio_info');
  if (folioInfo && e.target.className != 'folioIcon') {
    folioInfo.classList.remove('show-block');
  }
});

// remove shipping package protection product from cart and remove cart attr also
window.removeItemWithAttributes = function() {
  console.log("function called");
  var formData = new FormData();
  formData.append("updates[41918296719403]", 0);
  formData.append("attributes[_custom_shipping_protection]", "");

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    console.log("data",data);
    Rebuy.Cart.checkout();
  });
}

// Function to select the lowest price variant on product page load
function selectLowestPriceVariant() {
  // Get product JSON data
  const productJsonElement = document.querySelector('[id^="ProductJSON-"]');
  if (!productJsonElement) {
    // Retry after a short delay if product JSON is not yet available
    setTimeout(selectLowestPriceVariant, 200);
    return;
  }

  try {
    const productData = JSON.parse(productJsonElement.textContent);
    if (!productData || !productData.variants || productData.variants.length === 0) return;

    // Find the lowest price available variant
    let lowestPriceVariant = null;
    let lowestPrice = Infinity;

    productData.variants.forEach(variant => {
      if (variant.available && variant.price < lowestPrice) {
        lowestPrice = variant.price;
        lowestPriceVariant = variant;
      }
    });

    // If no available variant found, find the lowest price variant regardless of availability
    if (!lowestPriceVariant) {
      productData.variants.forEach(variant => {
        if (variant.price < lowestPrice) {
          lowestPrice = variant.price;
          lowestPriceVariant = variant;
        }
      });
    }

    if (!lowestPriceVariant) return;

    // Select the variant using the variant selectors
    const selectorWrappers = document.querySelectorAll('.product__block__variants .selector-wrapper');
    
    if (selectorWrappers.length > 0 && lowestPriceVariant.options) {
      selectorWrappers.forEach((selectBox, index) => {
        const variantOptionValue = lowestPriceVariant.options[index];
        if (!variantOptionValue) return;

        // Handle select dropdowns (popout selects)
        const anchorTags = selectBox.querySelectorAll('a[data-value]');
        if (anchorTags.length > 0) {
          anchorTags.forEach((anchorTag) => {
            if (anchorTag.getAttribute("data-value") === variantOptionValue) {
              anchorTag.click();
            }
          });
          return;
        }

        // Handle radio buttons
        const radioButtons = selectBox.querySelectorAll('.radio__button input[type="radio"], input[type="radio"][name^="options"]');
        if (radioButtons.length > 0) {
          radioButtons.forEach((radioInput) => {
            if (radioInput.value === variantOptionValue) {
              radioInput.checked = true;
              radioInput.dispatchEvent(new Event("change", { bubbles: true }));
            }
          });
        }
      });

      // Update the hidden variant ID input if it exists
      const variantIdInput = document.querySelector('input[name="id"][form], select[name="id"]');
      if (variantIdInput) {
        if (variantIdInput.tagName === 'INPUT') {
          variantIdInput.value = lowestPriceVariant.id;
        } else if (variantIdInput.tagName === 'SELECT') {
          variantIdInput.value = lowestPriceVariant.id;
          variantIdInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }

      // Trigger theme variant change event if the function exists (from product.liquid)
      if (typeof window.updateVariantDisplay === 'function') {
        window.updateVariantDisplay(lowestPriceVariant);
      }

      // Dispatch custom event for variant change
      const variantChangeEvent = new CustomEvent('theme:variant:change', {
        bubbles: true,
        detail: { variant: lowestPriceVariant }
      });
      document.dispatchEvent(variantChangeEvent);
    }
  } catch (error) {
    console.error('Error selecting lowest price variant:', error);
  }
}

// Select lowest price variant on page load
document.addEventListener("DOMContentLoaded", function () {
  // Wait a bit for the product form to be fully initialized
  // The product.liquid script uses 500ms timeout, so we'll use 600ms to ensure it runs after
  setTimeout(selectLowestPriceVariant, 600);
});

// Also handle the specific radio-wrapper case (existing functionality)
document.addEventListener("DOMContentLoaded", function () {
  const variantRadios = document.querySelectorAll('#radio-wrapper input[type="radio"]');

  if (!variantRadios.length) return;

  // Find the radio with the lowest price
  let lowestRadio = null;
  let lowestPrice = Infinity;

  variantRadios.forEach(radio => {
      let price = Number(radio.dataset.price);
      if (price < lowestPrice) {
          lowestPrice = price;
          lowestRadio = radio;
      }
  });

  // Auto-select the lowest price variant
  if (lowestRadio) {
      lowestRadio.checked = true;
      lowestRadio.dispatchEvent(new Event("change")); // Trigger the price update
  }
});

